import { useState } from "react";
import { History, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { when } from "@/lib/format";
import { ACTION_STYLE, ChangeList } from "@/lib/history";

export const EntryHistory = ({ entryId }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    if (items) return setItems(null);
    setBusy(true);
    try {
      const { data } = await api.get(`/entries/${entryId}/history`);
      setItems(data);
    } catch (ex) {
      toast.error(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-4 border-t border-slate-200 pt-3">
      <button type="button" data-testid="entry-history-toggle" onClick={load}
        className="text-xs font-semibold flex items-center gap-1.5 text-slate-700 hover:text-slate-900">
        {busy ? <Loader2 size={13} className="animate-spin" /> : <History size={13} />}
        {items ? "Hide change history" : "Show change history"}
      </button>
      {items && (
        <div className="mt-3 space-y-2" data-testid="entry-history-list">
          {items.length === 0 && <p className="text-xs text-slate-500" data-testid="entry-history-empty">No recorded changes (entry was made before history tracking).</p>}
          {items.map((h, i) => (
            <div key={i} className="border border-slate-200 bg-white px-3 py-2" data-testid="entry-history-item">
              <div className="flex flex-wrap items-center gap-2 text-[11px]">
                <span className={`font-bold uppercase tracking-[0.1em] px-1.5 py-0.5 ${ACTION_STYLE[h.action]}`}>{h.action}</span>
                <b>{h.by_name}</b>
                <span className="font-mono text-slate-500">{when(h.at)}</span>
              </div>
              <ChangeList changes={h.changes} action={h.action} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
